import React from "react";
import * as Icons from "lucide-react";

// Convert kebab-case icon name → PascalCase for lucide
const toPascal = (s) => s.split("-").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join("");

export function LucideIcon({ name, className = "w-4 h-4" }) {
  const Comp = Icons[toPascal(name || "star")] || Icons.Star;
  return <Comp className={className} />;
}
